import React from "react";
import { IoIosCart, IoIosHeart, IoIosPerson} from "react-icons/io";
import logo from "../../images/tracemall.png";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import { MdSort, MdSearch } from "react-icons/md";
import Badge from '@material-ui/core/Badge';

import {motion} from "framer-motion";

class Nav extends React.Component {

    state = {
        navLinks: this.props.navLinks
    }

    listLinks = () => {
        const links = this.state.navLinks.map((link) => {
            return <li key={link.id} ><Link className="link" to={`/${link.name}`}>{link.name}</Link></li>;
        });
        return <ul className="ul">{links}</ul>
    }

    render () {
        
        return (
            <nav className="nav" id="navigation">
                <Link to="/"><Logo selector="logo" image={logo} /></Link>
                {this.listLinks()}
                <RightWidgets cartCount={this.props.basket?.length ?? 0} wishCount={this.props.wishlist?.length ?? 0} />
            </nav>
        )
    }
}

function RightWidgets ({ cartCount, wishCount }) {
    return (
        <motion.div className="right-icons-container">
            
            <Badge className="vanish" badgeContent={ wishCount} color="secondary">
                <Link className="icon-links" to="/wishlist"><IoIosHeart className="icons wishlist-icon ripple" /></Link>
            </Badge>
            <Badge badgeContent={cartCount} color="secondary">
                <Link className="icon-links" to="/cart"><IoIosCart className="icons cart-icon ripple" /></Link>
            </Badge>
            
            <Link style={{textDecoration: "none"}} to="/login">
                <Button 
                    variant="contained"
                    color="primary"
                    endIcon={<IoIosPerson />}
                    className="ripple vanish auth"
                >Sign In</Button>
            </Link>

            <MdSearch className="icons ripple appear" />
            <MdSort className="icons ripple appear" />
        </motion.div>
    )
}

function Logo ({ image, selector }) {
    return (
        <img alt="something graphical" src={ image } className={ selector } />
    )
}

const matchStateToProps = (state) => {
    return {
      basket: state.basket,
      wishlist: state.wishlist
    }
  }
  
//   const matchDispatchToProps = (dispatch) => {
//     return{
//         addToCart: (item) => dispatch({type: "ADD_TO_CART", payload:{item} })
//     }
//   }

export default connect(matchStateToProps)(Nav);